import { useTranslation } from 'react-i18next';
import React from 'react';
import PropTypes from 'prop-types';
import { REASONS } from '@fec/frontend-aron/foundation/hooks/usePlayerIsBlocked';
import { capitalizeFirstLetter } from '@fec/assets/js/utils/string-formatter';
import {
  formatDate,
  formatTime,
} from '@fec/assets/js/utils/date-time-formatter';

import './MediaBlockingNotice.scss';

const MediaBlockingNotice = ({ asset, reason }) => {
  const { t } = useTranslation();
  const displayType = capitalizeFirstLetter(asset.type);

  let message = '';
  if (reason === REASONS.validTo) {
    message = t('playerWidget.mediumNotAvailable', { type: displayType });
  } else if (reason === REASONS.validFrom) {
    const date = formatDate(asset.validFrom);
    const time = formatTime(asset.validFrom);
    message = t('playerWidget.mediumAvailableFrom', {
      date,
      time,
      type: displayType,
    });
  } else {
    return null;
  }

  return <div className="media-blocking-notice">{message}</div>;
};

MediaBlockingNotice.propTypes = {
  asset: PropTypes.shape({
    type: PropTypes.string,
    validTo: PropTypes.string,
    validFrom: PropTypes.string,
  }),
  reason: PropTypes.string,
};

export default MediaBlockingNotice;
